import { render, staticRenderFns } from "./TabelaRelacionamentosPj.vue?vue&type=template&id=7005613b&lang=pug"
import script from "./TabelaRelacionamentosPj.vue?vue&type=script&lang=js"
export * from "./TabelaRelacionamentosPj.vue?vue&type=script&lang=js"
import style0 from "./TabelaRelacionamentosPj.vue?vue&type=style&index=0&id=7005613b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports